/**
 * Mounts the CheckUp calculation reconciler ONCE for the signed-in app. (F26)
 *
 * Sits above the router (see `core/app/App.tsx`), inside the journey context,
 * so a calculation that finishes while the citizen is on the dashboard — or
 * anywhere else — refreshes the score everywhere it is read. The CheckUp page
 * and the dashboard card only READ the cache; nothing screen-level reconciles.
 *
 * Keyed exactly as those screens key their CheckUp reads: the auth user id
 * and the active journey. An empty id keeps it idle until sign-in.
 */
import { useAuth, useCheckUpCalculationReconciler } from '@tonnie/sdk';

import { useJourneyInstance } from '@/core/contexts/JourneyInstanceContext';

export function CheckUpCalculationReconciler(): null {
  const { user } = useAuth();
  const { activeInstance } = useJourneyInstance();
  useCheckUpCalculationReconciler(user?.id ?? '', activeInstance?.id);
  return null;
}
